import { useAtom } from "jotai";

import { type View } from "_/state/viewer";

import { GCodeMesh } from "./gcode-mesh";

type GcodeViewProps = {
  view: View<"prepare">;
};

export const GCodeView = ({ view }: GcodeViewProps) => {
  const color = 0x0088ff;

  const [viewControls] = useAtom(view.controlsAtom);

  const printData = view.data.printData;

  const [bottomLayer, topLayer] = viewControls.layer.value;

  return (
    <GCodeMesh
      printData={printData}
      color={color}
      bottomLayer={bottomLayer}
      topLayer={topLayer}
    />
  );
};
